/**
 * Sons silenciados? — vale para todos os sons do site (gestão e área do aluno):
 * aviso de notificação, toasts e alertas (lbAlert), formulários (lbForm),
 * confete e chat. O botão de silenciar e a troca entre abas ficam em
 * templates/parts/notificacoes-navegador.php, que define a mesma função
 * (mesma chave) — aqui só garante que ela exista em qualquer página.
 */
if (typeof window.lbSonsMudos !== 'function') {
	window.lbSonsMudos = function () {
		try { return localStorage.getItem('lb_sons_mudos') === '1'; } catch (e) { return false; }
	};
}
